import { ECaseType } from '../../types/frontend/case-type.enum';

export const APRIL_MADNESS_PACK_VARIANT = {
  ZIP_1: 'zip_1',
  ZIP_2: 'zip_2',
  ZIP_3: 'zip_3',
  ZIP_4: 'zip_4',
  ZIP_5: 'zip_5',
} as const;

export type AprilMadnessPackVariant = (typeof APRIL_MADNESS_PACK_VARIANT)[keyof typeof APRIL_MADNESS_PACK_VARIANT];

export interface AprilMadnessCollectionPackStyle {
  readonly image: string;
  readonly size: string;
  readonly position: string;
  readonly rotation: string;
}

const APRIL_MADNESS_COLLECTION_PACK_ATLAS_IMAGE = `url('/assets/spine-animations/april-madness/open-case-pack/zip_2.png')`;
const APRIL_MADNESS_COLLECTION_PACK_ATLAS_SIZE = '714.8342% 107.563%';

export const APRIL_MADNESS_COLLECTION_PACK_STYLE_BY_VARIANT: Record<AprilMadnessPackVariant, AprilMadnessCollectionPackStyle> = {
  [APRIL_MADNESS_PACK_VARIANT.ZIP_1]: {
    image: APRIL_MADNESS_COLLECTION_PACK_ATLAS_IMAGE,
    size: APRIL_MADNESS_COLLECTION_PACK_ATLAS_SIZE,
    position: '64.8311% 2.7778%',
    rotation: '0deg',
  },
  [APRIL_MADNESS_PACK_VARIANT.ZIP_2]: {
    image: APRIL_MADNESS_COLLECTION_PACK_ATLAS_IMAGE,
    size: APRIL_MADNESS_COLLECTION_PACK_ATLAS_SIZE,
    position: '48.7369% 2.7778%',
    rotation: '180deg',
  },
  [APRIL_MADNESS_PACK_VARIANT.ZIP_3]: {
    image: APRIL_MADNESS_COLLECTION_PACK_ATLAS_IMAGE,
    size: APRIL_MADNESS_COLLECTION_PACK_ATLAS_SIZE,
    position: '32.4439% 2.7778%',
    rotation: '0deg',
  },
  [APRIL_MADNESS_PACK_VARIANT.ZIP_4]: {
    image: APRIL_MADNESS_COLLECTION_PACK_ATLAS_IMAGE,
    size: APRIL_MADNESS_COLLECTION_PACK_ATLAS_SIZE,
    position: '16.3497% 2.7778%',
    rotation: '180deg',
  },
  [APRIL_MADNESS_PACK_VARIANT.ZIP_5]: {
    image: APRIL_MADNESS_COLLECTION_PACK_ATLAS_IMAGE,
    size: APRIL_MADNESS_COLLECTION_PACK_ATLAS_SIZE,
    position: '0.0568% 2.7778%',
    rotation: '0deg',
  },
};

export const APRIL_MADNESS_ZIP_PACK_BY_VARIANT: Record<AprilMadnessPackVariant, string> = {
  [APRIL_MADNESS_PACK_VARIANT.ZIP_1]: 'april_madness/zip_1',
  [APRIL_MADNESS_PACK_VARIANT.ZIP_2]: 'april_madness/zip_2',
  [APRIL_MADNESS_PACK_VARIANT.ZIP_3]: 'april_madness/zip_3',
  [APRIL_MADNESS_PACK_VARIANT.ZIP_4]: 'april_madness/zip_4',
  [APRIL_MADNESS_PACK_VARIANT.ZIP_5]: 'april_madness/zip_5',
};

export const getAprilMadnessPackVariant = (caseType?: ECaseType): AprilMadnessPackVariant => {
  switch (caseType) {
    case ECaseType.DARK_BLUE:
      return APRIL_MADNESS_PACK_VARIANT.ZIP_2;
    case ECaseType.PURPLE:
      return APRIL_MADNESS_PACK_VARIANT.ZIP_3;
    case ECaseType.LIGHT_PURPLE:
      return APRIL_MADNESS_PACK_VARIANT.ZIP_4;
    case ECaseType.RED:
    case ECaseType.YELLOW:
    case ECaseType.SUPER_PRIZE:
      return APRIL_MADNESS_PACK_VARIANT.ZIP_5;
    case ECaseType.NO_COLOR:
    case ECaseType.BLUE:
    default:
      return APRIL_MADNESS_PACK_VARIANT.ZIP_1;
  }
};
